import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Avatar,
  Chip
} from '@mui/material';
import { keyframes } from '@mui/system';
// import TeamCarousel from '../../components/TeamCarousel';
import { MemberCard, MemberGrid } from '../../components/MemberCard';
const fadeInSlideUp = keyframes`
from {
  opacity: 0;
  transform: translateY(20px);
}
to {
  opacity: 1;
  transform: translateY(0);
}
`;

const Board = () => {
  // TODO: Replace with Firebase fetch
  const boardMembers = [
    // {
    //   id: 1,
    //   name: "Mr. Kishore Vaghela",
    //   designation: "President",
    //   expertise: [
    //     "Education: BA (ECONOMICS ),M.A -1 (SOCIOLOGY)",
    //     "Business:  CANTEEN OR AGENCY OR CONSULTANTCY",
    //     "RESPONSIBILITY :-",
    //     " ABVP 1985 TO 2000",
    //     "BJYM :- 2000 TO 2006",
    //     "BJP :- 2006 TO TILL TODAY",
    //     "UNIVERSITY :- 1999 TO 2012",
    //     "SIXAN SAMITI :- 2010 TO 2015",
    //     "CHAIRMAN  :- SCHETO HOCKY ASSOCIATION GUJRAT",
    //     "PRESIDANT :- SURAT DIGITAL MALL",
    //     "DIRECTOR :- SHAHPORE URBEN CO OP SOCIETY, SURAT CITY",
    //     "HOBBY :- SEVA IN EDUCATION OR HEALTH OR PRAVASH"
    //   ],
    //   imageUrl: "/membersphoto/kishor-vaghela.jpg"
    // },
    {
      id: 2,
      name: "Mr. Bipin Patel",
      designation: "Secretary",
      expertise: [
        "Education: B.com",
        "Business: Textile Yarn & Gray Cloth Manufacturing (More than 26 years of experience)",

      ],
      imageUrl: "/membersphoto/Bipin-patel.jpg"
    },
    // {
    //   id: 3,
    //   name: "Mr. Mayur.R Patel",
    //   designation: "Vice President",
    //   expertise: [
    //     "Education: B.Com, LL.B, LL.M, PHD PURSUING (CRIMINAL LAW).",
    //     "Profession: PRECTISING ADVOCATE",
    //     "SOCIAL ORGANISATIONAL RESPONSIBILITIES: ",
    //     " ABVP KARYKARTA 1989 TO 2000 ACTIVE IN GUJRAT",
    //     " RSS NAGAR KARYVAH 2014 TO 2016 ADAJAN, SURAT.",
    //     " VHP JILLA SAHMANTRI, RANDER, SURAT. 2021.",
    //     " ACTIVE IN RSS TILL TODAY.",
    //     " COUNCIL MEMBER IN SURAT DIST BAR ASSOCIATIONS, SURAT. 2023"
    //   ],
    //   imageUrl: "/membersphoto/mayur-patel.jpg"
    // },
    {
      id: 4,
      name: "Mrs. Suniti Karwa",
      designation: "Vice President",
      expertise: [
        "Women entrepreneur",
        "Social worker promoting women's empowerment"
      ],
      imageUrl: "/membersphoto/suniti-karwa.jpg"
    },
    {
      id: 5,
      name: "Dr. Dhananjay Bhatt",
      designation: "Director",
      expertise: [
        "Career guidance",
        "Entrepreneurship promotion and innovation",
        "Intellectual Property Rights (IPR)",
        "UG/PG project guidance",
        "Learning with earning projects",
        "Business identification from cottage industries to SMEs",
        "Astrological guidance on career, job, and business"
      ],
      imageUrl: "/membersphoto/d.v-bhatt.jpg"
    },
    // {
    //   id: 7,
    //   name: "Dr. Anurag Kothari",
    //   designation: "Director",
    //   expertise: ["Social Worker"],
    //   imageUrl: "/membersphoto/Anurag-Kothari.jpg"
    // },
    {
      id: 8,
      name: "Mr. Jitendra Dina",
      designation: "Director",
      expertise: [
        "Education: B.com",
        "Business:  Diamond Trading & Jewellery Making (More than 27 years of experience"
      ],
      imageUrl: "/membersphoto/Jitendra-dina.jpg"
    },
    // {
    //   id: 9,
    //   name: "Mr. Hemendra Borsaliwala",
    //   designation: "Director",
    //   expertise: ["Social Worker"],
    //   imageUrl: "/membersphoto/hemendra-borsiwala.jpg"
    // },
    // {
    //   id: 10,
    //   name: "Mr. Piyush Bhatt",
    //   designation: "Director",
    //   expertise: [
    //     "Education: M.Com. ( Statistics.)",
    //     "Experience: Retired SBI Bank Officer (38Years of Banking Operations)",
    //     "Expertise: Faculty as,Motivational Speaker Enterpreneur Speaker",
    //     "Other Details: Connected with ART & LITERATURE since 45 years as writer, director in  Theatre, stage, TV artist, Script writer, Poet etc.",
    //   ],
    //   imageUrl: "/membersphoto/piyush-bhatt.jpg"
    // },
    // {
    //   id: 11,
    //   name: "Mr. Amit Sharma",
    //   designation: "Director",
    //   expertise: [
    //     "Purchasing techniques in the textile market",
    //     "Industrial guidance"
    //   ],
    //   imageUrl: "/membersphoto/amit-sharma.jpg"
    // },
    {
      id: 12,
      name: "Mr. Ranjitkumar Chaudhary",
      designation: "Director",
      expertise: [
        "Social worker"
      ],
      imageUrl: "/membersphoto/ranjit-chaudhary.jpg"
    },
    // {
    //   id: 13,
    //   name: "Mr. Dharmesh Shah",
    //   designation: "Advisor",
    //   expertise: [
    //     "Education :-  B.com.",
    //     "Occupation:- Officer, Surat National Co.-Op. Bank Ltd.",
    //     "Work Experience in Social :-",
    //     "Prant Mahasachiv, Bharat Vikas Parishad,  Gujarat South.",
    //     "Responsibilities of ABVP During 1997 to 2012.",
    //     "Vice Chairman, SNCB Staff Credit Society."

    //   ],
    //   imageUrl: "/membersphoto/dharmesh-shah.jpg"
    // },
    // {
    //   id: 14,
    //   name: "Mr. Anupam Jain",
    //   designation: "Advisor",
    //   expertise: [
    //     "Certified Financial Planner (CFP)",
    //     "MBA Finance",
    //     "Diploma in Banking & Finance ",
    //     "14 year work experience of Banking and Wealth Management",
    //     "Website Developer"
    //   ],
    //   imageUrl: "/membersphoto/anupam-jain.jpg"
    // },
    // {
    //   id: 15,
    //   name: "Mr. Nitin Oza",
    //   designation: "Advisor",
    //   expertise: [
    //     "How to train and promote entrepreneurship",
    //     "Physical development and self-developed products",
    //     "Career guidance"
    //   ],
    //   imageUrl: "/membersphoto/nitin-oza.jpg"
    // }
  ];
  const nationalMembers = [
    {
      id: 1,
      name: "Shri. Prakash Chandra Sahu",
      designation: "President-NYCS",
      imageUrl: "/membersphoto/prakash-chandra-sahu.png"
    },
    {
      id: 2,
      name: "Shri. Manish Kumar",
      designation: "Vice President ",
      imageUrl: "/membersphoto/Manish-Kumar.jpg"
    },
    {
      id: 3,
      name: "Shri. Rajesh Pande",
      designation: "Chairman ",
      imageUrl: "/membersphoto/Rajesh-babulal-pande.jpg"
    },
  ]



  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Header Section */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            mb: 10,
            background: 'linear-gradient(to right, #1976d2, #512da8)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          NYCS Board Members
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Our National Board Members
        </Typography>
      </Box>

      <Grid container spacing={4} sx={{ alignContent: "center", mb: 10 }}>
        {nationalMembers.map((member) => (
          <Grid item xs={12} sm={6} md={4} lg={4} key={member.id} sx={{ mb: { xs: 3, sm: 4, md: 5 } }}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: 3,
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
                  "& .member-avatar": {
                    transform: "scale(1.05)",
                  },
                  "& .member-overlay": {
                    opacity: 1,
                  },
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                },
                "&:hover::before": {
                  opacity: 1,
                },
                p: 3,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  mb: 2,
                }}
              >
                <Avatar
                  src={member.imageUrl}
                  alt={member.name}
                  className="member-avatar"
                  sx={{
                    width: { xs: 120, sm: 140, md: 160 },
                    height: { xs: 120, sm: 140, md: 160 },
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    border: "4px solid #ffffff",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                    },
                  }}
                />
                <Box
                  className="member-overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))",
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                  }}
                />
              </Box>

              <CardContent
                sx={{
                  textAlign: "center",
                  p: 0,
                  width: "100%",
                  "&:last-child": {
                    pb: 0,
                  },
                }}
              >
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.25rem" },
                    color: "text.primary",
                    lineHeight: 1.3,
                    transition: "color 0.3s ease",
                  }}
                >
                  {member.name}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "primary.main",
                    fontWeight: 500,
                    fontSize: { xs: "0.875rem", sm: "0.9rem" },
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    opacity: 0.9,
                    lineHeight: 1.4,
                  }}
                >
                  {member.designation}
                </Typography>

                {/* Optional: Add a subtle divider line */}
                <Box
                  sx={{
                    width: "40px",
                    height: "2px",
                    background: "linear-gradient(90deg, #667eea, #764ba2)",
                    margin: "12px auto 0",
                    borderRadius: "2px",
                    opacity: 0.6,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* SuratBoard Members Grid */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>

        <Typography
          variant="h5"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Meet our dedicated surat team of board members
        </Typography>
      </Box>
      <Grid container spacing={4} sx={{ alignContent: "center" }}>
        {boardMembers.map((member) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={member.id} sx={{ mb: { xs: 3, sm: 4, md: 5 } }}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: 3,
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
                  "& .member-avatar": {
                    transform: "scale(1.05)",
                  },
                  "& .member-overlay": {
                    opacity: 1,
                  },
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                },
                "&:hover::before": {
                  opacity: 1,
                },
                p: 3,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  mb: 2,
                }}
              >
                <Avatar
                  src={member.imageUrl}
                  alt={member.name}
                  className="member-avatar"
                  sx={{
                    width: { xs: 120, sm: 140, md: 160 },
                    height: { xs: 120, sm: 140, md: 160 },
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    border: "4px solid #ffffff",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                    },
                  }}
                />
                <Box
                  className="member-overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))",
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                  }}
                />
              </Box>

              <CardContent
                sx={{
                  textAlign: "center",
                  p: 0,
                  width: "100%",
                  "&:last-child": {
                    pb: 0,
                  },
                }}
              >
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.25rem" },
                    color: "text.primary",
                    lineHeight: 1.3,
                    transition: "color 0.3s ease",
                  }}
                >
                  {member.name}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "primary.main",
                    fontWeight: 500,
                    fontSize: { xs: "0.875rem", sm: "0.9rem" },
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    opacity: 0.9,
                    lineHeight: 1.4,
                  }}
                >
                  {member.designation}
                </Typography>

                {/* Optional: Add a subtle divider line */}
                <Box
                  sx={{
                    width: "40px",
                    height: "2px",
                    background: "linear-gradient(90deg, #667eea, #764ba2)",
                    margin: "12px auto 0",
                    borderRadius: "2px",
                    opacity: 0.6,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* <MemberGrid members={boardMembers} /> */}




    </Container>
  );
};

export default Board;
// const nationboardmembers = [
//   {
//     id: 1,
//       name: "Mr. Prakash Sahu",
//       designation: "President",
//       imageUrl: "/membersphoto/default.png"
//   },
//   {
//     id: 2,
//       name: "Mr. Manish Kumar",
//       designation: "Vice President ",
//       imageUrl: "/membersphoto/default.png"
//   },
//   {
//     id: 3,
//       name: "Mr. Rajesh Pande",
//       designation: "Chairman ",
//       imageUrl: "/membersphoto/default.png"
//   },
//   {
//       id: 4,
//       name: "Mr. Hiren Shah",
//       designation: "Director",
//       imageUrl: "/membersphoto/default.png"
//   },
//   {
//       id: 5,
//       name: "Mr.Jyotirmay Mahanto",
//       designation: "Director ",
//       imageUrl: "/membersphoto/default.png"

//   },
//   {
//     id: 6,
//     name: "Mr. Gaurav Pandey ",
//     designation:  "Director",
//     imageUrl: "/membersphoto/default.png"

// },
// {
//   id: 7,
//   name: "Mr. Raghav Garg",
//   designation: "Director ",
//   imageUrl: "/membersphoto/default.png"

// },
// {
//   id: 8,
//   name: "Mr. Ashutosh Gupta",
//   designation: "Director ",
//   imageUrl: "/membersphoto/default.png"

// },
// {
//   id: 9,
//   name: "Mr. Balu Gopal Krishna",
//   designation: "Director",
//   imageUrl: "/membersphoto/default.png"

// },
// {
//   id: 10,
//   name: "Mr. Prakruti Pandya",
//   designation: "Director ",
//   imageUrl: "/membersphoto/default.png"

// },


//   ]
// Firebase setup and data fetching
// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';

// const [boardMembers, setBoardMembers] = useState([]);

// useEffect(() => {
//   const fetchBoardMembers = async () => {
//     const db = getFirestore();
//     const boardCollection = collection(db, 'boardMembers');
//     const snapshot = await getDocs(boardCollection);
//     const members = snapshot.docs.map(doc => ({
//       id: doc.id,
//       ...doc.data()
//     }));
//     setBoardMembers(members);
//   };

//   fetchBoardMembers();
// }, []);